import React, {useEffect, useState} from 'react';
import {Modal, Form, Input, Select,  DatePicker, InputNumber, Alert, Button} from 'antd';
import { doc,  updateDoc } from 'firebase/firestore';
import {  db } from '@/firebaseConfig.js';




const UserModal = ({ open, onCancel, user, onSuccess }) => {
    const [form] = Form.useForm();
    const isEdit = !!user?.uid;
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        if (isEdit && user) {
            form.setFieldsValue({
                ...user,
            });
        } else {
            form.resetFields();
        }
    }, [user, form, isEdit]);


    const onFinish = async (values) => {
        try {
            setLoading(true);
            const userRef = doc(db, 'users', user.uid);

            // Обновляем все поля пользователя из формы
            await updateDoc(userRef, {
                ...values,
            });

            setSuccess(true);
            onSuccess?.();
        } catch (error) {
            console.error('Ошибка при сохранении:', error);
            setError(true);
        }finally {
            setLoading(false);
        }
    };


    return (
        <>
        {success && (
            <Alert
                message="User updated successfully!"
                type="success"
                showIcon
                closable
                onClose={() => setSuccess(false)}
            />
        )}

    {error && (
        <Alert
            message="Something went wrong!!"
            type="error"
            showIcon
            closable
            onClose={() => setError(false)}
        />
    )}
            <Modal
                title={isEdit ? 'Edit User' : 'Create User'}
                open={open}
                onCancel={onCancel}
                footer={null}
            >
                <Form form={form} layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[
                            { required: true, message: 'Enter email' },
                            { type: 'email', message: 'Enter a valid email' },
                        ]}
                    >
                        <Input disabled={isEdit} />
                    </Form.Item>

                    <Form.Item label="Role" name="role" initialValue="user">
                        <Input disabled={isEdit} />
                    </Form.Item>
                    <Form.Item label="Store Name" name="storeName" initialValue="storeName">
                        <Input  />
                    </Form.Item>

                    <Form.Item label="Telegram" name="telegram">
                        <Input placeholder="@username" />
                    </Form.Item>

                    <Form.Item label="Organization" name="organization">
                        <Input />
                    </Form.Item>

                    <Form.Item label="Balance" name="balance" initialValue={0}>
                        <Input type="number" min={0} />
                    </Form.Item>

                    <Form.Item label="Available" name="available" initialValue={0}>
                        <Input type="number" min={0} />
                    </Form.Item>
                    <Form.Item label="Cancel" name="cancel" initialValue={0}>
                        <Input type="number" min={0} />
                    </Form.Item>
                    <Form.Item label="Refound" name="refound" initialValue={0}>
                        <Input type="number" min={0} />
                    </Form.Item>
                    <Form.Item label="Total" name="total" initialValue={0}>
                        <Input type="number" min={0} />
                    </Form.Item>

                    <Form.Item label="Status" name="status" initialValue="moderation">
                        <Select>
                            <Select.Option value="moderation">In Moderation</Select.Option>
                            <Select.Option value="active">Active</Select.Option>
                            <Select.Option value="blocked">Blocked</Select.Option>
                        </Select>
                    </Form.Item>

                    <Form.Item>
                        <Button loading={loading} type="primary" htmlType="submit">Update</Button>
                    </Form.Item>
                </Form>
            </Modal>

        </>
    );
};

export default UserModal;
